// Tracking Modules
import {track_abstract} from '@utilities/track-abstract/track-abstract';

import {sal_fbq} from '@utilities/track-facebook/track-facebook';
import {sal_gtag} from '@utilities/track-google-analytics/track-google-analytics';
import {sal_linkedin} from '@utilities/track-linkedin/track-linkedin';
import {sal_pintrk} from '@utilities/track-pinterest/track-pinterest';
import {sal_wiredtrk} from '@utilities/track-wiredmindes/track-wiredminds';
import {UserCentricIds} from "@utilities/sal-usercentrics/sal-usercentrics";

track_abstract.use(UserCentricIds.FACEBOOK_PIXEL, sal_fbq);

track_abstract.use(UserCentricIds.GOOGLE_ANALYTICS, sal_gtag);

track_abstract.use(UserCentricIds.LINKEDIN_ANALYTICS, sal_linkedin);

track_abstract.use(UserCentricIds.PINTEREST, sal_pintrk);

track_abstract.use(UserCentricIds.WIREDMINDS, sal_wiredtrk, true);
